import React from 'react';
import { Box } from '@components/Box';
import { CloudImage } from '@components/CloudImage';
import { FindYourJoyContent } from './FindYourJoyContent';
import { useFindYourJoyController } from './FindYourJoy.controllers';
import {
  StyledTextPairing,
  StyledColumns,
  StyledColumn,
  RightColumn,
  LeftColumn,
  LeftCloudImage,
  BurstBox,
  CircleBox,
  CurlBox,
  BlobBox,
} from './FindYourJoy.styles';
import { useTranslation } from 'react-i18next';

export const FindYourJoyDesktop: React.FC = () => {
  const { containerRef, circleRef, curlRef } = useFindYourJoyController();
  const { t } = useTranslation('careers');
  const findYourJoyData = t('findYourJoy');
  return (
    <Box paddingTop={[0, 15]} marginTop={[-9, 0]} paddingBottom={[10, 13]} ref={containerRef}>
      <StyledColumns>
        <LeftColumn width={2}>
          <BurstBox>
            <CloudImage src="careers/find-your-joy/burst.svg" width="100%" height="100%" optimization="aggressive" />
          </BurstBox>
          <LeftCloudImage src="careers/find-your-joy/pic3-v2.jpg" width="265" optimization="aggressive" />
        </LeftColumn>
        <StyledColumn desktop={6} tablet={8} mobile={12}>
          <StyledTextPairing
            title={findYourJoyData.title}
            titleVariant="hed56"
            titleColor={'neutra6'}
            titleTagName="h2"
            body={findYourJoyData.body}
            bodyVariant="calloutDek40"
            bodyColor={'neutra5'}
            bodyTagName="h2"
          />
        </StyledColumn>
        <RightColumn desktop={4} tablet={2}>
          <CircleBox ref={circleRef}>
            <CloudImage src="careers/find-your-joy/gradient-cicle.svg" width="100%" height="100%" optimization="aggressive" />
          </CircleBox>
          <BlobBox>
            <CloudImage src="careers/find-your-joy/blob-v2.jpg" width="100%" height="100%" optimization="aggressive" />
          </BlobBox>
          <CloudImage src="careers/find-your-joy/pic1-v2.jpg" width="621" height="402" optimization="aggressive" />
          <CurlBox ref={curlRef}>
            <CloudImage src="careers/find-your-joy/curl.svg" width="100%" height="100%" optimization="aggressive" />
          </CurlBox>
        </RightColumn>
      </StyledColumns>
      <FindYourJoyContent id="desktop" />
    </Box>
  );
};
